<div class="w-full bg-white border-box radius-10 mb-20"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img src="assets/square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">3. Validation du scrutin blanc</p>
            <p class="no-margin dark-gray text-sm">Le bureau de vote doit valider explicitement le scrutin blanc avant
              le scellement.</p>
          </div>
        </div>
      </div>
      <!-- <app-tag [isValidated]="isValidated"></app-tag> -->
    </div>

  </div>


  <div id="information-grid" class="p-20" *ngIf="testStepStatus != 'AssessorTestValidated'">
    <div *ngIf="!isValidated" class="p-10 bg-pastel-orange radius-10" style="border: solid 1px #FDE68A;">
      <p class="bold orange no-margin">En attente du seuil de déscellement</p>
    </div>
    <div *ngIf="isValidated" class="bg-pastel-blue p-10 mb-10 radius-10">
      <p class="dark-blue bg-pastel-blue bold">
        Confirmez-vous le paramétrage du scrutin à blanc et les résultats obtenus ?
      </p>
      <div class="flex gap-10 mb-10">
        <v8te-active-button [buttonText]="'Non'" [primaryColor]="activeButton === 1 ? '#EF4444' : '#FFFFFF'"
          [textPrimaryColor]="activeButton === 1 ?'#FFFFFF' : '#2B2D67'" [border]="'solid 1px #D9D9D9'" [active]="true"
          (click)="setActiveButton(1)" [height]="50" [minWidth]="190" [width]="120"></v8te-active-button>

        <v8te-active-button [buttonText]="'Oui'" [primaryColor]="activeButton === 2 ? '#2B2D67' : '#FFFFFF'"
          [textPrimaryColor]="activeButton === 2 ?'#FFFFFF' : '#2B2D67'" [border]="'solid 1px #D9D9D9'" [active]="true"
          (click)="setActiveButton(2)" [height]="50" [minWidth]="190" [width]="120"></v8te-active-button>
      </div>

      <div *ngIf="activeButton === 1" class="p-20 bg-light-red radius-10" style="border: solid 1px #EF4444;">
        <p class="bold no-margin strong-red mb-5">Vous avez indiqué que le scrutin blanc n'est pas satisfaisant.</p>
        <p class="no-margin strong-red mb-10">
          Vous pouvez recommencer la procédure complète du scrutin à blanc depuis le début.
        </p>
        <v8te-active-button [buttonText]="'Recommencer le scrutin à blanc'" [primaryColor]="'#EF4444'"
          [textPrimaryColor]="'#FFFFFF'" [border]="'solid 1px #EF4444'" [height]="50" [minWidth]="190"
          [widthPercent]="100" (click)="testConfirmation(false)"></v8te-active-button>
      </div>

      <div *ngIf="activeButton === 2" class="p-20 bg-pastel-green radius-10" style="border: solid 1px #D2F8DD;">
        <p class="bold no-margin strong-green mb-5">Vous avez indiqué que le scrutin blanc est satisfaisant.</p>
        <p class="no-margin strong-green mb-10">Vous pouvez continuer la procédure complète du scrutin à blanc.</p>
        <v8te-active-button [buttonText]="'Confirmer la validation du scrutin blanc'" [primaryColor]="'#61B969'"
          [textPrimaryColor]="'#FFFFFF'" [border]="'solid 1px #61B969'" [height]="50" [minWidth]="190"
          [widthPercent]="100" (click)="testConfirmation(true)"></v8te-active-button>
      </div>
    </div>

  </div>

  <div *ngIf="testStepStatus == 'AssessorTestValidated'" class="p-20 flex flex-column gap-10">
    <div class="bg-pale-green p-10 radius-10 flex gap-10" style="border: solid 1px #D2F8DD;">
      <img src="assets/valid-circle-icon.svg" alt="valid icon" width="20px">
      <p class="no-margin strong-green">Le scrutin à blanc et ses résultats ont été validés par le bureau de vote.</p>
    </div>

    <div class="bg-pale-green p-10 radius-10 flex gap-10" style="border: solid 1px #D2F8DD;">
      <img src="assets/valid-circle-icon.svg" alt="valid icon" width="20px">
      <p class="no-margin strong-green">Les urnes ont été vidées.</p>
    </div>

    <div class="bg-pale-green p-10 radius-10 flex gap-10" style="border: solid 1px #D2F8DD;">
      <img src="assets/valid-circle-icon.svg" alt="valid icon" width="20px">
      <p class="no-margin strong-green">Le système est prêt pour le scellement officiel.</p>
    </div>
  </div>
</div>